import './component-registry.less'
import {
  Accolades,
  Alert,
  HeroSectionFront,
  HeroTopicFront,
  ArticleHeroPillar,
  ArticleHeroSatellite,
  Spotlight,
  Cta,
  TwoColumnBanner,
  BackToTop,
  AdviceSpotlight,
  RelatedInfo,
  SkipLinks,
  ComplexHero,
  LogoutNotices,
  SocialShare,
  LogoutMessage,
  Assessment,
  Caption,
  Carousel,
  AnchorLinks,
  Commitments,
  AdvisorQuestion,
  CardCollection,
  Categories,
  BrandIcon,
  ArticleRightRail,
  Interstitial,
  LoginBanner,
  TwoColumnCard,
  TwoColumnCardItem,
  SuggestedLinks,
  CustomerServiceSidePanel,
  SearchResults,
  OneColumnBanner,
  Tabs,
  Testimonial,
  Promo,
  DynamicAdvisor,
  Quiz,
  DataPrivacyPreferenceCenter,
  MarketWatch,
  Milestones,
  TileList,
  AdvisorProfile,
  ChipNavigator,
  ShowOneElement
} from '@ampcore/design-system'
import Form from '../components/Form'
import {
  CampaignHeader,
  CampaignFooter
} from '../components/CampaignPage/index'
import { Accordion } from '@ampcore/adel-react'
import { VideoPlayer } from '@ampcore/video-player'
import { ComponentRegistry } from '@ampcore/react-to-web-component'

export const componentRegistry: ComponentRegistry = {
  Accordion: { component: Accordion },
  Accolades: { component: Accolades },
  AdvisorQuestion: { component: AdvisorQuestion },
  AdviceSpotlight: { component: AdviceSpotlight },
  AdvisorProfile: { component: AdvisorProfile },
  Alert: { component: Alert },
  AnchorLinks: { component: AnchorLinks },
  CustomerServiceSidePanel: { component: CustomerServiceSidePanel },
  ArticleHeroPillar: { component: ArticleHeroPillar },
  ArticleHeroSatellite: { component: ArticleHeroSatellite },
  ArticleRightRail: { component: ArticleRightRail },
  Assessment: { component: Assessment },
  BackToTop: { component: BackToTop },
  BrandIcon: { component: BrandIcon },
  CampaignFooter: { component: CampaignFooter },
  CampaignHeader: { component: CampaignHeader },
  CardCollection: { component: CardCollection },
  Caption: { component: Caption },
  Carousel: { component: Carousel },
  Categories: { component: Categories },
  ChipNavigator: { component: ChipNavigator },
  Commitments: { component: Commitments },
  ComplexHero: { component: ComplexHero },
  Cta: { component: Cta },
  DataPrivacyPreferenceCenter: { component: DataPrivacyPreferenceCenter },
  DynamicAdvisor: { component: DynamicAdvisor },
  Form: { component: Form },
  HeroSectionFront: { component: HeroSectionFront },
  HeroTopicFront: { component: HeroTopicFront },
  Interstitial: { component: Interstitial },
  LoginBanner: { component: LoginBanner },
  LogoutMessage: { component: LogoutMessage },
  LogoutNotices: { component: LogoutNotices },
  MarketWatch: { component: MarketWatch },
  Milestones: { component: Milestones },
  TileList: { component: TileList },
  Promo: { component: Promo },
  OneColumnBanner: { component: OneColumnBanner },
  Quiz: { component: Quiz },
  RelatedInfo: { component: RelatedInfo },
  SearchResults: { component: SearchResults },
  ShowOne: { component: ShowOneElement },
  SkipLinks: { component: SkipLinks },
  SocialShare: { component: SocialShare },
  Spotlight: { component: Spotlight },
  SuggestedLinks: { component: SuggestedLinks },
  Testimonial: { component: Testimonial },
  TwoColumnBanner: { component: TwoColumnBanner },
  TwoColumnCard: { component: TwoColumnCard },
  TwoColumnCardItem: { component: TwoColumnCardItem },
  Tabs: { component: Tabs },
  VideoPlayer: { component: VideoPlayer }
}
